// ポップアップ警告を表示する関数
function showWarningPopup() {
  const popupOverlay = document.createElement("div");
  popupOverlay.className = "warning-popup-overlay";

  const popup = document.createElement("div");
  popup.className = "warning-popup";
  popup.innerHTML = `
    <div class="warning-popup-content">
      <h3>注意</h3>
      <p>カートの商品数が上限を超えています。</p>
      <p>カート内の商品数を減らして、<br/>決済後に再度ご購入ください。</p>
      <button class="warning-popup-close">閉じる</button>
    </div>
  `;

  popupOverlay.appendChild(popup);
  document.body.appendChild(popupOverlay);

  // 閉じるボタンのイベントリスナー
  const closeButton = popup.querySelector(".warning-popup-close");
  closeButton.addEventListener("click", () => {
    popupOverlay.remove();
  });

  // オーバーレイクリックでも閉じる
  popupOverlay.addEventListener("click", (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.remove();
    }
  });
}

// 警告メッセージを表示する関数
function showWarningMessage() {
  const messageDiv = document.createElement("div");
  messageDiv.className = "cart-warning";
  messageDiv.innerHTML = `
    <div class="alert alert-warning error-message" role="alert">
      カートの商品数が上限に達しました。<br/>
      カート内の商品を減らして調整してください。
    </div>
  `;

  // メッセージを表示する場所を指定
  document.querySelector("#cart-notification").appendChild(messageDiv);
}

// 警告メッセージを非表示にする関数
function hideWarningMessage() {
  const warningMessage = document.querySelector(".cart-warning");
  if (warningMessage) {
    warningMessage.remove();
  }
}

// 「カートに追加」ボタンを無効化する関数
function disableAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll('[name="checkout"]');
  addToCartButtons.forEach((button) => {
    button.disabled = true;
    button.innerHTML = "カートの上限に達しました";
  });
}
// 「カートに追加」ボタンを有効化する関数
function enableAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll('[name="checkout"]');
  addToCartButtons.forEach((button) => {
    button.disabled = false;
    button.innerHTML = "カートに追加";
  });
}

// カート内のアイテム数を取得する関数
async function getCartItemCount(num = 0) {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    // すべてのアイテムの数量を合計
    const totalItems = cart.items.reduce((total, item) => {
      return total + item.quantity + num;
    }, 0);

    // 合計を表示または使用する
    updateCartCount(totalItems);
    hideWarningMessage();
    console.log("カート内のアイテム数:", totalItems);

    if (totalItems > 10) {
      // 「カートに追加」ボタンを無効化
      disableAddToCartButtons();
      // 警告メッセージを表示
      showWarningMessage();

      // ポップアップ警告を表示
      showWarningPopup();
    }
    if (totalItems <= 10) {
      // 「カートに追加」ボタンを有効化
      enableAddToCartButtons();
      hideWarningMessage();
    }

    return totalItems;
  } catch (error) {
    console.error("カートの取得に失敗しました:", error);
    return 0;
  }
}

// カートの合計数を更新する関数
function updateCartCount(count) {
  // カートの合計を表示する要素を更新
  const cartCountElements = document.querySelectorAll("[data-cart-quantity]");
  cartCountElements.forEach((element) => {
    element.textContent = count;
  });
}
document.addEventListener("DOMContentLoaded", () => {
  getCartItemCount();
});
// // カートの変更を監視する設定
// document.addEventListener("DOMContentLoaded", () => {
//   // 初期読み込み時に合計を取得
//   getCartItemCount();

//   // 数量入力フィールドの変更を監視（セレクターを修正）
//   const quantityInputs = document.querySelectorAll('input[name^="updates["]');

//   quantityInputs.forEach((input) => {
//     input.addEventListener("change", async (e) => {
//       console.log("数量が変更されました:", e.target.value);
//       //スピナーを表示
//       const spinner = document.querySelector(".spiner_custum");
//       spinner.innerHTML = `
//       <div class="loading-modal-overlay">
//      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#ffffff">
//     <circle cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0"/>
//     </circle>
//     <circle transform="rotate(45 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".125s"/>
//     </circle>
//     <circle transform="rotate(90 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".25s"/>
//     </circle>
//     <circle transform="rotate(135 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".375s"/>
//     </circle>
//     <circle transform="rotate(180 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".5s"/>
//     </circle>
//     <circle transform="rotate(225 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".625s"/>
//     </circle>
//     <circle transform="rotate(270 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".75s"/>
//     </circle>
//     <circle transform="rotate(315 12 12)" cx="12" cy="2" r="2" opacity=".1">
//         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".875s"/>
//     </circle>
// </svg>
// </div>
//       `;

//       // 少し遅延を入れてShopifyのカート更新を待つ
//       setTimeout(async () => {
//         //スピナーを非表示
//         spinner.innerHTML = "";
//         await getCartItemCount();
//       }, 3000);
//     });
//   });

//   // Ajax APIによるカート更新後のイベントを監視
//   document.addEventListener("cart:updated", async () => {
//     await getCartItemCount();
//   });
// });


class CartWarning {
  constructor() {
    this.warningThreshold = 10;
    this.setupEventListeners();
    this.addWarningElement();
  }

  setupEventListeners() {
    // カート更新時のイベントリスナー
    document.addEventListener("cart:updated", this.handleCartUpdate.bind(this));

    // 商品数量変更時のイベントリスナー
    document.addEventListener("change", (event) => {
      if (event.target.matches("[data-quantity-input]")) {
        this.handleQuantityChange(event);
      }
    });
  }

  addWarningElement() {
    // 警告メッセージ要素がまだ存在しない場合のみ追加
    if (!document.querySelector("[data-cart-warning]")) {
      const warningHTML = `
        <div class="cart-warning" 
          data-cart-warning 
          style="display: none; background: #fff3cd; color: #856404; padding: 1rem; margin: 1rem 0; border-radius: 4px;">
          <div class="cart-warning__content">
            カートの商品数が${this.warningThreshold}点以上です。大量注文の場合は、お手数ですが当店までご連絡ください。
          </div>
        </div>
      `;
      const cartForm = document.querySelector("[data-cart-form]");
      if (cartForm) {
        cartForm.insertAdjacentHTML("beforebegin", warningHTML);
      }
    }
  }

  async handleCartUpdate(event) {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      this.updateWarningVisibility(cart.item_count);
    } catch (error) {
      console.error("カート情報の取得に失敗しました:", error);
    }
  }

  async handleQuantityChange(event) {
    console.log("数量が変更されました:", event.target.value);
    const quantityInput = event.target;
    const newQuantity = parseInt(quantityInput.value, 10);
    const spinner = document.querySelector(".spiner_custum");
    try {
   spinner.innerHTML = `
       <div class="loading-modal-overlay">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#ffffff">
     <circle cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0"/>
     </circle>
     <circle transform="rotate(45 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".125s"/>
     </circle>
     <circle transform="rotate(90 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".25s"/>
     </circle>
     <circle transform="rotate(135 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".375s"/>
     </circle>
     <circle transform="rotate(180 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".5s"/>
     </circle>
     <circle transform="rotate(225 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".625s"/>
     </circle>
     <circle transform="rotate(270 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".75s"/>
     </circle>
     <circle transform="rotate(315 12 12)" cx="12" cy="2" r="2" opacity=".1">
         <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".875s"/>
     </circle>
 </svg>
 </div>
       `;

      hideWarningMessage();
      setTimeout(async () => {
        // 数量が変更された時点での他の商品も含めた合計を取得
        const response = await fetch("/cart.js");
        const cart = await response.json();
        const totalItems = cart.items.reduce((sum, item) => {
          return sum + item.quantity;
        }, 0);
        console.log("カート内の合計商品数:", totalItems);
         if (totalItems > 10) {

          console.log("カート内の合計商品数10以上です");
           // 「カートに追加」ボタンを無効化
           disableAddToCartButtons();
           // 警告メッセージを表示
           showWarningMessage();   

           // ポップアップ警告を表示
           showWarningPopup();
         }
         if (totalItems <= 10) {
          console.log("カート内の合計商品数10以下です");
           // 「カートに追加」ボタンを有効化
           enableAddToCartButtons();
           hideWarningMessage();
         }
        this.updateWarningVisibility(totalItems);
         spinner.innerHTML = "";
      }, 3000);
      
    } catch (error) {
      console.error("カート情報の取得に失敗しました:", error);
    }
  }

  updateWarningVisibility(itemCount) {
    const warningElement = document.querySelector("[data-cart-warning]");
    if (!warningElement) return;

    if (itemCount >= this.warningThreshold) {
      warningElement.style.display = "block";
      // アニメーション効果を追加（オプション）
      warningElement.style.animation = "fadeIn 0.3s ease-in-out";
    } else {
      warningElement.style.display = "none";
      spinner.innerHTML = "";
    }
  }
}

// スタイルの追加
const style = document.createElement("style");
style.textContent = `
  .cart-warning {
    transition: all 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;
document.head.appendChild(style);

// インスタンス化
document.addEventListener("DOMContentLoaded", () => {
  new CartWarning();
});